<div class="grid p-5">
    <div class="grid flex mt-5">
        <div class="col-12 flex justify-content-center mt-5">
            <img [src]="image" [alt]="alt" width="75px" height="85px" />
        </div>

        <div class="col-5 mx-auto my-4">
            <p class="info mb-0 text-center">{{ message }}</p>
        </div>

        <div class="col-12 flex justify-content-center" *ngIf="showUpload">
            <p-fileUpload name="demo[]" #fileUpload (onSelect)="fileSelect.emit($event)" [showUploadButton]="false"
                [accept]="accept" [maxFileSize]="maxFileSize" mode="basic" [chooseLabel]="buttonLabel"
                [chooseIcon]="buttonIcon" class="file-upload"></p-fileUpload>
        </div>
        <div class="col-12 flex justify-content-center" *ngIf="openForm">
            <p-button [label]="buttonLabel" [icon]="buttonIcon" class="action-btn mx-1"
                (onClick)="openFormEvent.emit(buttonLabel)">
            </p-button>
        </div>
    </div>
</div>